import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
// Children
import {OrganizationContainer} from './containers/organization/organization.container';
import {OrganizationListPageContainer} from './containers/organization-list-page/organization-list-page.container';
import {CreateOrganizationPageContainer} from './containers/create-organization-page/create-organization-page.container';
import {OrganizationListGuard} from './guards/organization-list.guard';
import {CreateOrganizationGuard} from './guards/create-organization.guard';
import {OrganizationPendingComponent} from './components/organization-pending/organization-pending.component';

const routes: Routes = [
  {
    path: '',
    component: OrganizationContainer,
    children: [
      {
        path: '',
        redirectTo: 'list',
        pathMatch: 'full'
      },
      {
        path: 'list',
        component: OrganizationListPageContainer,
        canActivate: [OrganizationListGuard]
      },
      {
        path: 'new',
        component: CreateOrganizationPageContainer,
        canActivate: [CreateOrganizationGuard]
      },
      {
        path: 'wait',
        component: OrganizationPendingComponent
        // canActivate: [OrgInviteGuard]
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    OrganizationListGuard,
    CreateOrganizationGuard
  ]
})

export class OrganizationRoutingModule {
}
